<template>
    <v-card class="ma-4 px-4" style="height: calc(100% - 36px);" outlined :loading="loading">
        <v-card-title>
            <v-icon class="mr-2">mdi-chat-processing</v-icon>
            Jiwai List
            <v-spacer></v-spacer>
            <v-btn color="green" dark class="mr-2" @click="refreshData">
                <v-icon left>mdi-refresh</v-icon>
                Refresh
            </v-btn>
            <v-btn color="primary" class="mr-2" @click="add">
                <v-icon left>mdi-plus</v-icon>
                Add
            </v-btn>
            <v-btn
                color="orange"
                dark
                @click="
                    deleteOneOrMore = 1;
                    deleteDialogShow = true;
                "
            >
                <v-icon left>mdi-trash-can-outline</v-icon>
                Delete
            </v-btn>
        </v-card-title>
        <v-data-table
            ref="dataTable"
            v-model="selectedJiwaiList"
            :headers="headers"
            :items="jiwaiList"
            :items-per-page="20"
            :server-items-length="serverTotalCount"
            item-key="ID"
            show-select
            :footer-props="footer"
            @click:row="viewJiwai"
            @update:page="pageJiwai"
        >
        </v-data-table>

        <v-dialog v-model="jiwaiDialogShow" max-width="500">
            <v-form>
                <v-card>
                    <v-card-title class="headline primary lighten-2 mb-4">Jiwai View</v-card-title>
                    <v-card-text class="subtitle-1 black--text">
                        <v-text-field v-model="viewedJiwai.Title" :counter="20" label="Title" required></v-text-field>
                        <v-textarea label="Markdown" v-model="viewedJiwai.Markdown"></v-textarea>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="grey" text @click="jiwaiDialogShow = false">
                            Close
                        </v-btn>
                        <v-btn color="primary" @click="saveJiwai"> <v-icon>mdi-content-save</v-icon>Save </v-btn>
                        <v-btn
                            color="orange"
                            v-if="viewedJiwai.IDStr !== undefined"
                            @click="
                                deleteOneOrMore = 0;
                                deleteDialogShow = true;
                            "
                            ><v-icon>mdi-trash-can-outline</v-icon>Delete</v-btn
                        >
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>

        <v-dialog v-model="deleteDialogShow" max-width="500">
            <v-card>
                <v-card-title class="headline warning lighten-2 mb-4">Delete the Jiwai(s) Forever?</v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey" text @click="deleteDialogShow = false">
                        No
                    </v-btn>
                    <v-btn color="warning" text @click="deleteJiwai()">
                        Yes
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
import { apiGetJiwaiList, apiSaveJiwai, apiDeleteJiwai } from "@/api/jiwai";
import { Log } from "@/utils/debug";

export default {
    name: "JiwaiList",
    data: () => ({
        loading: true,
        headers: [
            { text: "Title", align: "left", sortable: false, value: "Title", width: "200px" },
            { text: "Content", align: "left", sortable: false, value: "Markdown" },
            { text: "DateTime", value: "DateStr", sortable: false, width: "170px" }
        ],
        footer: {
            "items-per-page-options": [10]
        },
        serverTotalCount: 0,
        jiwaiList: [],
        selectedJiwaiList: [],
        currentPage: 0,
        jiwaiDialogShow: false,
        viewedJiwai: {},
        deleteOneOrMore: 0 /* 0:single, 1:more */,
        deleteDialogShow: false
    }),
    methods: {
        refreshData() {
            this.loading = true;
            apiGetJiwaiList({ pageSize: 10, page: this.currentPage })
                .then(resp => {
                    Log.debug(resp);
                    this.jiwaiList = resp.data.JiwaiList;
                    this.serverTotalCount = resp.data.TotalCount;
                })
                .catch(err => {
                    Log.error(err);
                });
            this.loading = false;
        },
        add() {
            this.viewedJiwai = {};
            this.jiwaiDialogShow = true;
        },
        viewJiwai(jiwai) {
            this.viewedJiwai = jiwai;
            this.jiwaiDialogShow = true;
        },
        pageJiwai(page) {
            this.currentPage = page - 1;
            this.refreshData();
        },
        saveJiwai() {
            apiSaveJiwai(this.viewedJiwai).then(() => {
                this.jiwaiDialogShow = false;
                this.refreshData();
            });
        },
        deleteJiwai() {
            let jiwaiList = [];
            if (this.deleteOneOrMore === 0) {
                jiwaiList[0] = this.viewedJiwai.IDStr;
            } else {
                for (let index in this.selectedJiwaiList) {
                    jiwaiList.push(this.jiwaiList[index].IDStr);
                }
            }

            apiDeleteJiwai(jiwaiList).then(() => {
                this.refreshData();
                this.deleteDialogShow = false;
                this.jiwaiDialogShow = false;
            });
        }
    },
    mounted() {
        this.refreshData();
    }
};
</script>

<style scoped></style>
